import { createTheme, css } from "@mui/material/styles";

import { getColor } from "@hooks";

const inputBorderRadius = "4px";

export const breakpointsAndComponentsTheme = createTheme({
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 744,
      desktop: 1024,
      desktopXl: 1440,
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          ...theme.typography.paragraph_large_medium,
          "textTransform": "none",

          "backgroundColor": getColor(c => c.tokens.bg["strong-950"], theme),
          ":hover": {
            backgroundColor: getColor(c => c.tokens.bg["surface-800"], theme),
          },

          "color": getColor(c => c.tokens.text["white-0"], theme),
          "&.Mui-disabled": {
            color: getColor(c => c.tokens.text["sub-600"], theme),
          },

          "width": "fit-content",
          "padding": "14px 24px",
          "borderRadius": "10px",
          "& .MuiButton-endIcon": {
            marginLeft: "4px",
            marginRight: "0",
          },
          "& .MuiButton-startIcon": {
            marginLeft: "0px",
            marginRight: "4px",
          },
        }),
        text: ({ theme }) => ({
          "backgroundColor": "transparent",
          ":hover": {
            backgroundColor: getColor(c => c.tokens.bg["weak-50"], theme),
          },
          "color": getColor(c => c.tokens.text["strong-950"], theme),
        }),
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: ({ theme }) => ({
          "& .MuiOutlinedInput-notchedOutline": {
            border: `1px solid ${getColor(c => c.tokens.stroke["soft-200"], theme)}`,
            borderRadius: inputBorderRadius,
          },
          "& .MuiOutlinedInput-input": {
            padding: "14.5px 12px",
          },
          "&.MuiInputBase-multiline": {
            padding: "0",
          },
          "& .MuiInputAdornment-root": {
            color: getColor(c => c.tokens.text["soft-400"], theme),
          },
          "background": getColor(c => c.tokens.bg["soft-200"], theme),
          "fontFamily": "Work Sans",
          "fontSize": "14px",
        }),
        input: ({ theme }) => ({
          color: getColor(c => c.tokens.text["strong-950"], theme),
          borderRadius: inputBorderRadius,
        }),
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: ({ theme }) => ({
          "& .MuiFormHelperText-root": {
            textTransform: "none",
            ...theme.typography.paragraph_xsmall_regular,
          },
        }),
      },
    },
    MuiCssBaseline: {
      styleOverrides: (theme: {
        palette: { text: { primary: string } };
      }) => css`
        body {
          letter-spacing: 0;
        }
        a {
          text-decoration: none;
          color: ${theme.palette.text.primary};
        }
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        p,
        ul,
        ol {
          margin-block-start: 0;
          margin-block-end: 0;
        }
      `,
    },
  },
});
